import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Time in milliseconds that unused/inactive cache data remains in memory
      // Time in milliseconds that cache data remains in memory after becoming unused
      cacheTime: 10 * 60 * 1000, // 10 minutes
      // Reduce retry attempts to prevent UI freezing
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors except 408, 429
        if (
          error?.status >= 400 &&
          error?.status < 500 &&
          ![408, 429].includes(error.status)
        ) {
          return false;
        }
        // Retry only once for other errors to prevent UI freezing
        return failureCount < 1;
      },
      // Shorter retry delay to prevent long freezes
      retryDelay: (attemptIndex) => Math.min(500 * 2 ** attemptIndex, 5000),
      // Refetch on window focus
      refetchOnWindowFocus: false,
      // Refetch on reconnect
      refetchOnReconnect: true,
      // Add timeout to prevent hanging requests
      timeout: 10000, // 10 seconds
    },
    mutations: {
      // Don't retry failed mutations to prevent UI freezing
      retry: 0,
      // Shorter retry delay for mutations
      retryDelay: 500,
      // Add timeout for mutations
      timeout: 15000, // 15 seconds
    },
  },
});

// Global error handler
queryClient.setMutationDefaults(["auth"], {
  mutationFn: async (variables) => {
    // Global auth mutation logic
    throw new Error("Mutation not implemented");
  },
  onError: (error) => {
    console.error("Auth mutation error:", error);
  },
});

// Global query defaults for specific query keys
queryClient.setQueryDefaults(["users"], {
});

queryClient.setQueryDefaults(["dashboard"], {
});
